var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15452_44974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52734 3.20709L11.9408 0.703125L20.4756 3.20709L11.9408 5.51677L3.52734 3.20709Z",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3519 4.05469V8.82042H14.4537C13.0719 8.82042 11.9519 9.94106 11.9519 11.3235C11.9519 9.94106 10.8317 8.82042 9.45005 8.82042H6.52734V4.05469",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1793 21.1086C16.8953 21.1086 17.4758 20.5281 17.4758 19.8121C17.4758 19.0961 16.8953 18.5156 16.1793 18.5156C15.4633 18.5156 14.8828 19.0961 14.8828 19.8121C14.8828 20.5281 15.4633 21.1086 16.1793 21.1086Z",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 23.3039C22.7156 23.3039 23.2961 22.7234 23.2961 22.0074C23.2961 21.2914 22.7156 20.7109 21.9996 20.7109C21.2836 20.7109 20.7031 21.2914 20.7031 22.0074C20.7031 22.7234 21.2836 23.3039 21.9996 23.3039Z",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4766 19.8149V13.3594L23.2984 14.9435V22.0036",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 16.8188C0.703125 15.3008 1.93069 14.0703 3.44498 14.0703C4.61025 14.0703 5.60555 14.799 6.00258 15.8265C6.39956 14.799 7.39491 14.0703 8.56017 14.0703C10.2371 14.0675 11.3258 15.3753 11.2947 17.0264C11.2209 20.9468 6.00075 23.2933 6.00075 23.2933C5.95298 23.2861 0.703125 21.0415 0.703125 16.8188Z",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15452_44974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.5ad47841c8ff024ba2275d16197c38ac.svg";
export { ForwardRef as ReactComponent };